import {
    createContext,
    useCallback,
    useEffect,
    useMemo,
    useState,
} from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocalStorage } from '../hooks/use-local-storage';
import { jwtDecode } from 'jwt-decode';

export const AUTH_DATA_KEY = 'auth-data';

const AuthContext = createContext({
    user: {},
    login: (data) => {},
    logout: () => {},
});

export const AuthProvider = ({ children }) => {
    const [authData, setAuthData] = useLocalStorage(AUTH_DATA_KEY, null);
    const [session, setSession] = useState();
    const navigate = useNavigate();

    useEffect(() => {
        if (authData) {
            const decoded = jwtDecode(authData.accessToken);

            const newSession = {
                user: {
                    givenName: decoded.given_name,
                    name: decoded.name,
                    email: decoded.email,
                    menu: decoded.menu,
                },
            };

            setSession(newSession);
        } else {
            setSession(null);
        }
    }, [authData]);

    const login = useCallback(
        async (data) => {
            setAuthData(data);
            navigate('/', { replace: true });
        },
        [setAuthData, navigate]
    );

    const logout = useCallback(() => {
        setAuthData(null);
        navigate('/login', { replace: true });
    }, [setAuthData, navigate]);

    const context = useMemo(
        () => ({
            isAuthenticated: !!authData,
            session,
            login,
            logout,
        }),

        [session, login, logout, authData]
    );

    return (
        <AuthContext.Provider value={context}>{children}</AuthContext.Provider>
    );
};

export default AuthContext;
